module.exports = __webpack_public_path__ + "static/media/instruct2.5eca78a4.png";